// components/Adminstor.js
import React from "react";
import AddMazane from "../components/AddMazane";
import TabloManager from "../components/TabloManager";
import RegisterRequest from "./RegisterRequest";
import UserList from "./UserList";
import PendingTradesList from "./PendingTradesList";
import TradeList from "./TradeList";
import BalanceEditor from "./BalanceEditor";
import VitrinMasseges from "./VitrinMasseges";
import TransferManagement from "./TransferManagement";

function Adminstor({ selected }) {
  return (
    <div style={{ padding: "20px", flex: 1 }}>
      <h2>{selected}</h2>
      {selected === "تابلو" && <TabloManager />}
      {selected === "ایجاد مظنه جدید" && <AddMazane />}
      {selected === "درخواست ورود" && <RegisterRequest />}
      {selected === "لیست کاربران" && <UserList />}
      {selected === "تراکنش جدید" && <PendingTradesList />}
      {selected === "لیست تراکنش ها" && <TradeList />}
      {selected === "امور ثبت حواله" && <TransferManagement />}
      {selected === "ایجاد گردش حساب" && <BalanceEditor />}
      {selected === "ویترین و پیام ها" && <VitrinMasseges />}
    </div>
  );
}

export default Adminstor;
